export enum CustomerType {
	INDIVIDUAL = 'individual',
	COMPANY = 'company',
}
